<template>
    <Table :table-settings="concurrencyTenderTableSettings" :debounce="debounce"
        :columns="columns"
        :itemsDataProvider="concurrencyTableDataProvider"
        :sort-options="contractsSortOptions" ref="concurrency_data_table" :enable-search="false" :enable-sort="false"
         @row-clicked="(item) => {
                if (item.is_supplier) {
                    $router.push({
                        name: 'supplier-detail',
                        params: {
                            version: version,
                            hash: hash,
                            slug: item.slug
                        }
                    });
                }
            }
            ">
        <template v-slot:data_flags_count="row">
            <span class="badge rounded-pill bg-danger">{{ row.item.flags_count }}</span>
        </template>

        <template v-slot:data_flags="row">
            <FlagDetailRowToggler :row="row" :callback="toggleConcurrencyRowDetail" />
        </template>

        <template v-slot:row_details="row">
            <FlagDetailRow :row="row" :version="version" />
        </template>
    </Table>
</template>

<script>
import Table from "@/components/Table.vue";
import dataTableMixin from "@/plugins/dataTableMixin.js";
import tableSettingsMixin from "@/plugins/tableSettingsMixin.js";
import FlagDetailRowToggler from "@/components/FlagDetailRowToggler.vue";
import FlagDetailRow from "@/components/FlagDetailRow.vue";
export default {
    props: {
        version: { required: true },
        hash: { required: true },
        typeId: { required: true },
        tenderSlug: { required: true },
        debounce: { type: Number, required: false, default: 700 }
    },
    components: {
        Table,
        FlagDetailRowToggler,
        FlagDetailRow
    },
    mixins: [dataTableMixin, tableSettingsMixin],
    data: function (data) {
        return {
            columns: [
                {
                    key: "name",
                    label: this.$t("tenderDetail.concurrency.table.head.name"),
                    thClass: "text-start text-nowrap text-xl-nowrap",
                    class: "text-start",
                    isActive: true
                },
                {
                    key: "flags",
                    label: this.$t("tenderDetail.concurrency.table.head.flags"),
                    thClass: "text-end",
                    class: "text-end detailsButtonColumn p-0",
                    isActive: true
                },
            ],
            concurrencyTenderTableSettings: {
                isBusy: false,
                initialized: false,
                selectedSortOptionValue: 0,
                filter: {},
                emptyText: this.$t("table.empty"),
                emptyFilteredText: this.$t("table.filter.empty"),
                tbodyTrClass: (item) => (item && item.is_supplier ? "clickable" : ""),
                filterTimeout: null,
                filterExpanded: false,
                orderingExpanded: false,
                fieldsExpanded: false,
                flagsExpanded: false,
            }
        }
    },
    methods: {
        concurrencyTableDataProvider: function (ctx) {
            var params = this.initRequestParams(ctx);

            params["tender_slug"] = this.tenderSlug;
            params[`${this.version}_hash`] = this.hash;

            return this.$store.getters.api
                .get("get_concurrency/", { params: params })
                .then((response) => {
                    var data = response.data.concurrency;
                    this.$refs.concurrency_data_table.setTotalRows(response.data.total_count);
                    return data;
                })
                .catch((e) => {
                    console.dir(e);
                    return [];
                });
        },
        toggleConcurrencyRowDetail: function (row) {
            row.item.toggleDetails();
        },
    }
}
</script>